import { render, staticRenderFns } from "./Usuario_info_basica.vue?vue&type=template&id=aff6b434&"
import script from "./Usuario_info_basica.vue?vue&type=script&lang=js&"
export * from "./Usuario_info_basica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports